// extracted by mini-css-extract-plugin
module.exports = {"form":"UsuarioNovo_form__kcqe5","atencao":"UsuarioNovo_atencao__1Xv4r","logTitulo":"UsuarioNovo_logTitulo__ydNsT","msgLogin":"UsuarioNovo_msgLogin__2wrt9"};